import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { BankThatWeWorkViewModel } from 'src/app/models/bankThatWeWorkViewModel';
import { BankService } from 'src/app/services/bank.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-bank-account',
  templateUrl: './bank-account.component.html',
  styleUrls: ['./bank-account.component.scss'],
})
export class BankAccountComponent implements OnInit {

  form: FormGroup;
  banks: BankThatWeWorkViewModel[] = [];
  bond;
  typeKey = 0;

  constructor(private modalCrtl: ModalController, private service: BankService, private toastCtrl: ToastController,
              private fb: FormBuilder, private loadingCtrl: LoadingController) {
    this.form = this.fb.group({
      nameBank: ["PIX", Validators.compose([
        Validators.required
      ])],
      favored: ['', Validators.compose([
        Validators.minLength(10),
        Validators.maxLength(100),
        Validators.required
      ])],
      agency: ['', Validators.compose([
      ])],
      account: ['', Validators.compose([
      ])],
      document: ['', Validators.compose([
        Validators.required
      ])],
      bond: [0, Validators.compose([
        Validators.required
      ])],
      keyPix: [''],
      typeKeyPix:[0]
    });
  }

  ngOnInit() {
    this.loadBond();
    this.loadBanks();
  }

  async loadBanks() {
    //this.bond = Security.getCoin();

    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.service.getBankThatWeWorkByCoin(this.bond).subscribe(result => {

      if (result.success) {
        this.banks = result.data;
        loading.dismiss();
      }
    });
  }

  async changeType(event){
    this.typeKey = event;
    this.form.patchValue({
      typeKeyPix: event,
      keyPix: "",
    });
  }


  loadBond(){
    const coin = Security.getCoin();
    if (coin === '1') {
      this.bond = 1;
    }

    if (coin === '2') {
      this.bond = 2;
    }

    if (coin === '3') {
      this.bond = 3;
    }
  }

  async save() {
    const loading = await this.loadingCtrl.create({ message: 'Salvando...' });
    loading.present();

    this.form.patchValue({
      bond: this.bond,
    });


    this.service.createBank(this.form.value).subscribe(result => {
      if (result.success) {
        loading.dismiss();
        this.close();
        this.showMessage(result.message);
      }
      this.showMessage(result.message);
      loading.dismiss();
    }, error => {
      this.showMessage(error.message);
    });
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }


  close() {
    this.modalCrtl.dismiss();
  }
}
